import { render } from "./ProfileThemeDefault.vue?vue&type=template&id=08ffcd02"
import script from "./ProfileThemeDefault.vue?vue&type=script&lang=js"
export * from "./ProfileThemeDefault.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/themes/old_layouts/ProfileThemeDefault.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08ffcd02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08ffcd02', __exports__)) {
    api.reload('08ffcd02', __exports__)
  }
  
  module.hot.accept("./ProfileThemeDefault.vue?vue&type=template&id=08ffcd02", () => {
    api.rerender('08ffcd02', render)
  })

}


export default __exports__